module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/focus--low-carbon.e898c80.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/focus--low-carbon.pdf
// module id = j2Z1
// module chunks = 10